import type { SsoUser } from '@domain/entities';
import type { IUserRepository } from '@domain/repositories';
import type {
  InviteUserPayload,
  PaginatedResult,
  ResetPasswordResult,
  UserFilters,
} from '@application/dto';
import type { IHttpClient } from '@application/ports';
import { API_ENDPOINTS } from '@infrastructure/config';

export class UserRepository implements IUserRepository {
  constructor(private readonly httpClient: IHttpClient) {}

  async list(filters: UserFilters): Promise<PaginatedResult<SsoUser>> {
    const response = await this.httpClient.get<PaginatedResult<SsoUser>>(
      API_ENDPOINTS.users.base,
      {
        params: {
          page: filters.page,
          limit: filters.limit,
          ...(filters.search ? { search: filters.search } : {}),
          ...(filters.status ? { status: filters.status } : {}),
          ...(filters.userType ? { userType: filters.userType } : {}),
        },
      }
    );

    return response.data;
  }

  async invite(payload: InviteUserPayload): Promise<SsoUser> {
    const response = await this.httpClient.post<SsoUser>(API_ENDPOINTS.users.invite, payload);
    return response.data;
  }

  async suspend(id: string): Promise<SsoUser> {
    const response = await this.httpClient.patch<SsoUser>(API_ENDPOINTS.users.suspend(id));
    return response.data;
  }

  async reactivate(id: string): Promise<SsoUser> {
    const response = await this.httpClient.patch<SsoUser>(API_ENDPOINTS.users.reactivate(id));
    return response.data;
  }

  async resetPassword(id: string): Promise<ResetPasswordResult> {
    const response = await this.httpClient.patch<ResetPasswordResult>(
      API_ENDPOINTS.users.resetPassword(id)
    );
    return response.data;
  }
}
